'use strict';

var util = require('../../../../app_fbb_core/cartridge/js/util');

/**
 * @function
 * @description Calls the service to pause Genesys call recording (mute).
 * window.recordingMuted is set synchronously to true; cleared to false only on network error.
 * @param {string} extension - the phone extension
 */
function muteGenesys(extension) {
    window.recordingMuted = true;
    var url = util.appendParamToURL(Urls.genesysMuteRecording, 'extension', extension);
    var xhr = $.ajax({
        url: url,
        method: 'POST',
        error: function () {
            window.recordingMuted = false;
        },
        complete: function () {
            if (window.recordingMuteDeferred === xhr) {
                window.recordingMuteDeferred = null;
            }
        }
    });
    window.recordingMuteDeferred = xhr;
}

/**
 * @function
 * @description Calls the service to resume Genesys call recording (unmute).
 * @param {string} extension - the phone extension
 */
function unmuteGenesys(extension) {
    window.recordingMuted = false;
    var url = util.appendParamToURL(Urls.genesysUnmuteRecording, 'extension', extension);
    $.ajax({
        url: url,
        method: 'POST',
        error: function () {
            window.recordingMuted = true;
        }
    });
}

function hasUrlPart(url, part) {
    return !!part && url.indexOf(part) > -1;
}

function isRecordingApiCall(url) {
    return hasUrlPart(url, Urls.genesysMuteRecording)
        || hasUrlPart(url, Urls.genesysUnmuteRecording)
        || hasUrlPart(url, Urls.verintMuteRecording)
        || hasUrlPart(url, Urls.verintUnmuteRecording);
}

exports.init = function (extension) {

    $(window).unload(function () {
        if (window.recordingMuted) {
            unmuteGenesys(extension);
        }
    });

    if (window.pageContext && window.pageContext.ns == 'checkout') {
        if ($('.billing-cards-section').is(':visible')) {
            if (!window.recordingMuted) {
                muteGenesys(extension);
            }
        }
        $(document).ajaxSuccess(function (event, xhr, settings) {
            if (!isRecordingApiCall(settings.url) && settings.url.indexOf(Urls.summaryRefreshURL) == -1) {
                if ($('.billing-cards-section').length > 0) {
                    if (!window.recordingMuted) {
                        muteGenesys(extension);
                    }
                }
            }
        });
        $(document).on('mousedown touchstart', function (e) {
            var $info = $('.billing-cards-section');
            if (!$info.is(e.target) && $info.has(e.target).length === 0) {
                if (window.recordingMuted) {
                    unmuteGenesys(extension);
                }
            } else {
                if (!window.recordingMuted) {
                    muteGenesys(extension);
                }
            }
        });

        if (SitePreferences.GENESYS_ENABLED && SitePreferences.IS_GENESYS_CREDITCARD_MASKING_ENABLED) {
            $(document).on('blur', '.creditcardnumber input', function () {
                if (!util.getCookie('csr_extension').length) { return; }
                if ($(this).val().length > 0) {
                    $(this).css('-webkit-text-security', 'disc');
                }
            });
            $(document).on('focus', '.creditcardnumber input', function () {
                if (!util.getCookie('csr_extension').length) { return; }
                var $field = $(this);
                var unmaskIfFocused = function () { if ($field.is(':focus')) { $field.css('-webkit-text-security', ''); } };
                var settleDelay = SitePreferences.GENESYS_MUTE_SETTLE_DELAY || 150;
                if (window.recordingMuteDeferred) {
                    // apply delay only when Genesys confirms mute success in the response body
                    window.recordingMuteDeferred
                        .done(function (data) {
                            if (data && data.success) {
                                setTimeout(unmaskIfFocused, settleDelay);
                            } else {
                                unmaskIfFocused();
                            }
                        })
                        .fail(unmaskIfFocused);
                } else {
                    unmaskIfFocused();
                }
            });
        }
    }

    if (window.pageContext && window.pageContext.ns == 'account') {
        if ($('.left-cont.payment-fields').is(':visible')) {
            if (!window.recordingMuted) {
                muteGenesys(extension);
            }
        }
        $(document).on('click', '.add-card', function (e) {
            if (!window.recordingMuted) {
                muteGenesys(extension);
            }
        });
        $(document).on('click', '.left-cont.payment-fields', function (e) {
            if (!window.recordingMuted) {
                muteGenesys(extension);
            }
        });
        $(document).on('click', '#applyBtn, .cancel-button', function (e) {
            if (window.recordingMuted) {
                unmuteGenesys(extension);
            }
        });
    }
};
